<section class="mx-3">
    <div class="row align-items-center mb-2">
        <div class="col-sm-8">
            <div class="d-flex align-items-center">
                <div>
                    <button mat-icon-button class="back_icon me-2" (click)="backPage()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                </div>
                <!-- <div *ngIf="BatchData"> -->
                <div>
                    <h4 class="m-0">Regulation Code: {{academicsemisterdata.academic_regulation_code}} - Course:
                        {{academicsemisterdata.course_name}} - Students List</h4>
                </div>
            </div>
        </div>
        <div class="col-sm-4">
            <form *ngIf="filtersectionForm" [formGroup]="filtersectionForm" (ngSubmit)="filterStudents()">
                <div>
                    <div *ngFor="let question of questions">
                        <app-question [question]="question" [form]="filtersectionForm"></app-question>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div>
        <table mat-table [dataSource]="studentdataSource" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="d-flex align-items-center">
                        <mat-checkbox (change)="$event ? toggleAllRows() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                        </mat-checkbox>
                        <ng-container *ngIf="this.selection.selected.length>0">
                            <button mat-icon-button class="action_button" [matMenuTriggerFor]="actionrequest"
                                aria-label="menu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #actionrequest="matMenu">
                                <ng-container>
                                    <button mat-menu-item class="action_button" (click)="assignstudentpromote()">
                                        <span>Promote next sem</span>
                                    </button>
                                </ng-container>
                            </mat-menu>
                        </ng-container>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row.id) : null"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Position Column -->
            <ng-container matColumnDef="index">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>No.</th>
                <td mat-cell *matCellDef="let element">{{ element.id }}</td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.first_name }} {{ element.last_name }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Course_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Course</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.course_name }}
                </td>
            </ng-container>

            <ng-container matColumnDef="phone_number">
                <th mat-header-cell *matHeaderCellDef>Mobile Number</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.phone_number }}
                </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email</th>
                <td mat-cell *matCellDef="let element">{{ element.email }}</td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="Dost_ID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Dost ID</th>
                <td mat-cell *matCellDef="let element">{{ element.Dost_ID }}</td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="Roll_No">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Roll No</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.roll_number }}
                </td>
            </ng-container>
            <!-- <ng-container matColumnDef="Department">
        <th mat-header-cell *matHeaderCellDef>Department</th>
        <td mat-cell *matCellDef="let element">{{ element.course_name }}</td>
      </ng-container> -->

            <ng-container matColumnDef="Academic_Year">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Academic Year
                </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.Academic_Year }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td class="cursor_pointer" mat-cell *matCellDef="let element">
                    view
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row.id)"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data</td>
            </tr>
        </table>
    </div>
</section>